import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"40\" height=\"40\" fill=\"#4EBC73\" fill-opacity=\".2\" rx=\"16\"></rect><path fill=\"url(#a)\" fill-rule=\"evenodd\" d=\"M30 20c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10m-12.667-1.333a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667m6.06-2.202a.89.89 0 0 1 0 1.257l-5.814 5.813a.889.889 0 1 1-1.257-1.257l5.813-5.813a.89.89 0 0 1 1.257 0m-2.06 6.202a1.333 1.333 0 1 0 2.666 0 1.333 1.333 0 0 0-2.666 0\" clip-rule=\"evenodd\"></path><defs><linearGradient id=\"a\" x1=\"28.547\" x2=\"1.967\" y1=\"11.178\" y2=\"40.47\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#40B160\"></stop><stop offset=\"1\" stop-color=\"#40B160\" stop-opacity=\"0\"></stop></linearGradient></defs>", 3)
  ])))
}
export default { render: render }